"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLastSeenHotelClick = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const trackLastSeenHotelClick = (language, objectId) => {
    (0, libs_tracking_events_1.track)({
        event: `last_seen_hotels`,
        action: `navigate`,
        label: objectId,
        category: `Zuletzt besuchte Hotels`,
        component: 'last-seen-hotels',
        position: 'content: bottom',
        language,
        _clear: true,
    });
};
exports.trackLastSeenHotelClick = trackLastSeenHotelClick;
//# sourceMappingURL=trackLastSeenHotels.js.map